import { EntityMultiSelect, Form } from '@domain-group/suit-theme'

import useAgencies from '@hooks/useAgencies'
import useBrandGroups from '@hooks/useBrandGroups'
import useBrandProvider from '@hooks/useBrandProvider'
import useCurrentUser from '@hooks/useCurrentUser'

import EntitySelector from '@components/EntitySelector'

import useBulkCreateAgencyProviderPackagesModal from '../../hooks/useBulkCreateAgencyProviderPackagesModal'

type SelectAgenciesProps = {
  bulkCreateAgencyProviderPackagesPayload: ReturnType<typeof useBulkCreateAgencyProviderPackagesModal>,
  isTopModal: boolean,
}

const SelectAgencies = (props: SelectAgenciesProps) => {
  const { bulkCreateAgencyProviderPackagesPayload, isTopModal } = props
  const {
    agencies,
    callbacks: {
      setSelectedEntityIds,
    },
    debouncedString,
    providerPackage,
    selectedEntityIds,
    searchForm,
  } = bulkCreateAgencyProviderPackagesPayload

  const {
    entityState: {
      brand_id, brand_group_id, string,
    },
    setEntityState: setSearchState,
    handlers,
  } = searchForm

  const agenciesPayload = useAgencies({
    filters: {
      // @ts-expect-error TS2339
      assigned_provider_id: providerPackage.provider_id,
      brand_id,
      brand_group_id,
      string: debouncedString,
    },
    performHttpRequests: debouncedString ? debouncedString.length > 1 : true,
    requestOptions: {
      include_agency_assigned_brand_group_ids: true,
      include_agency_assigned_provider_ids: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencies,
    filteredAgenciesCount,
    loading,
  } = agenciesPayload

  const filteredAgencyIds = filteredAgencies.map(agency => agency.id)

  const { filteredBrandGroups } = useBrandGroups({ filters: { brand_id } })

  const {
    callbacks: { addBrandProvider },
  // @ts-expect-error TS2339
  } = useBrandProvider({ provider_id: providerPackage.provider_id })

  const { isProviderDirector } = useCurrentUser()

  return (
    <>
      <EntitySelector
        callbacks={{
          selectItem: brand => setSearchState({
            brand_id: brand ? brand.id : null,
            brand_group_id: '',
            string: '',
          }),
        }}
        entityKey="brands"
        label="Brand"
        requestOptions={{
          include_brand_brand_groups: true,
        }}
        searchForwardProps={{
          listAction: (
            !isProviderDirector && (
              // @ts-expect-error TS2741
              <EntitySelector.CreateEntity
                onClick={() => addBrandProvider()}
                strings={{ create: 'Assign to Provider to enable' }}
              />
            )
          ),
        }}
        shouldRefetch={isTopModal}
        // @ts-expect-error TS2339
        searchRequestOptions={{ assigned_provider_id: providerPackage.provider_id }}
        selectedItemId={brand_id}
      />

      <Form.Field label="Brand Group" marginTop="large">
        {/*
         // @ts-expect-error TS2322 */}
        <select
          disabled={!brand_id}
          name="brand_group_id"
          value={brand_group_id}
          {...handlers}
        >
          <option value="">{brand_id ? 'Select Brand Group' : 'Please Select Brand'}</option>
          {filteredBrandGroups.map(brandGroup => (
            <option key={brandGroup.id} value={brandGroup.id}>
              {brandGroup.title}
            </option>
          ))}
        </select>
      </Form.Field>

      <Form.Field label="Agency Title" marginTop="large">
        <input onChange={e => setSearchState({ string: e.target.value })} value={string} />
      </Form.Field>

      {(brand_id || !!selectedEntityIds.length) && (
        // @ts-expect-error TS2741
        <EntityMultiSelect
          boxProps={{ marginTop: 'large' }}
          callbacks={{
            loadMore,
            setSelectedIds: setSelectedEntityIds,
          }}
          canLoadMore={canLoadMore}
          entities={agencies}
          entityCount={brand_id ? filteredAgenciesCount : 0}
          filteredEntityIds={brand_id ? filteredAgencyIds : []}
          loading={loading}
          selectedIds={selectedEntityIds}
        />
      )}
    </>
  )
}

export default SelectAgencies
